import React from 'react'
import { NavLink } from 'react-router-dom'
import styles from './styles.module.css'

const TopNavBar = (props) => {
  const { isMobile } = props
  return (
    <div className={isMobile ? styles.mobileContainer : styles.container}>
      <NavLink
        className={styles.header}
        style={{ fontSize: isMobile ? 16 : 22 }}
        to='/'
      >
        Gifted Charts
      </NavLink>
      {isMobile ? null : (
        <div className={isMobile ? styles.tagLineMobile : styles.tagLine}>
          Bring life to your data
        </div>
      )}
    </div>
  )
}

export default TopNavBar
